<template>
  <div class="community">
    <h2>Community Involvement</h2>
    <ul>
      <li v-for="item in volunteering" :key="item.info" :data="item">
        {{ item.info }} <span class="date">{{ item.date }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { volunteering } from "@/data/about.js";

export default {
  name: "Community",
  data() {
    return { volunteering };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";
@import "./style.scss";

.community {
  ul {
    li {
      font-family: "Roboto", sans-serif;
      font-size: $font-XS;
      margin: 10px 0 0 0;

      .date {
        color: $accent-blue;
        font-family: "PT Mono", monospace;
        font-size: $font-XS;
        margin-bottom: 0;
      }
    }
  }
}
</style>
